import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
var defaultItemsPerPage = 15;
export default {
  name: 'NiotaClassicDevicesListsOriginatorDevicesList',
  props: {
    list: {
      type: Array,
      required: false,
      default: new Array()
    },
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    originator: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      devices: [],
      deviceTypeId: null,
      tableHeaders: [{
        text: this.$i18n_t('NiotaClassic.Devices.table.name'),
        value: 'name',
        align: 'start'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.eui'),
        value: 'eui',
        align: 'start'
      }, {
        text: this.$i18n_t('NiotaClassic.Devices.table.originator'),
        value: 'originator',
        align: 'start'
      }, {
        sortable: false
      }],
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      operationalStatus: [{
        value: 0,
        text: this.$i18n_t('NiotaClassic.Devices.form.unset')
      }, {
        value: 1,
        text: this.$i18n_t('NiotaClassic.Devices.form.inTransit')
      }, {
        value: 2,
        text: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation')
      }, {
        value: 3,
        text: this.$i18n_t('NiotaClassic.Devices.form.inOperation')
      }, {
        value: 4,
        text: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive')
      }, {
        value: 5,
        text: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    n1Protocol: function n1Protocol() {
      return process.env.VUE_APP_N1_API_PROTOCOL;
    },
    n1Host: function n1Host() {
      return process.env.VUE_APP_N1_API_HOST;
    }
  }),
  watch: {
    list: function list() {
      this.initData();
    }
  },
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      this.devices = cloneDeep(this.list);
    },
    niota1ImageUrl: function niota1ImageUrl(imagePath) {
      if (imagePath) {
        if (/^http(?:s):\/\//i.test(imagePath)) {
          return imagePath;
        }

        return "".concat(this.n1Protocol, "://").concat(this.n1Host).concat(imagePath);
      }

      return '';
    },
    deleteFromList: function deleteFromList(item) {
      this.$emit('update', item);
    },
    filterOpStatusItems: function filterOpStatusItems(item, queryText) {
      return item.text.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    filterItems: function filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    setDeviceTypeId: function setDeviceTypeId() {
      this.$emit('setDeviceTypeId', this.deviceTypeId);
    },
    setOperationalStatus: function setOperationalStatus() {
      this.$emit('setOperationalStatus', this.operationStatus);
    }
  }
};